<template>
    <div class="mails-container">
        <h1 class="title is-5">Emails - {{ label_text }}</h1>
        <div class="mails-top-bar columns">
            <div class="column is-2">
                <compose-button />
            </div>
            <div class="column is-7">
                <search-bar />
            </div>
        </div>
        <br />
        <emails-login v-if="!isSignedIn"></emails-login>
        <emails-list v-else-if="shouldShowList"></emails-list>
        <router-view v-else></router-view>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import ComposeButton from '../../modules/emails/compose/ComposeButton'
import EmailsList from './EmailsList'
import EmailsLogin from './EmailsLogin'
import { SearchBar } from "../../modules/emails";

export default {
    components: { ComposeButton, EmailsList, EmailsLogin, SearchBar },
    computed: {
        ...mapGetters([
            'emails_is_signed_in',
            'emails_label',
            'emails_labels',
        ]),
        isSignedIn() {
            return this.emails_is_signed_in
        },
        label_text() {
            if (!this.emails_is_signed_in) {
                return ''
            }
            const label = this.emails_label.split(',')[0],
                text = !!this.emails_labels[label] && this.emails_labels[label].name || ''
            return text
        },
        shouldShowList() {
            const { fullPath, params: { label } } = this.$route
            const path = !!label && `/${label}` || ''
            return fullPath === `/emails${path}`
        },
    },
    data() {
        return {
            labels_loaded: false,
        }
    },
    methods: {
        ...mapActions([
            'emails_set_label',
            'emails_set_messages',
        ]),
    },
    mounted() {
        let { label = '' } = this.$route.params
        label = (!!label && (this.emails_set_label(label), label)) || this.emails_label

    },
    watch: {
        $route(to, from) {
            let { label } = to.params
            if (to.name === 'emails') {
                this.emails_set_messages([])
                this.emails_set_label(label)
            }
        },
    },
}
</script>

<style>
.mails-container .mails-top-bar {
  display: flex; }

</style>